// Google map creation
(function($) {

  // Generate marker
  function add_marker( $marker, map ) {
    // var
    var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

    // create marker
    var map_pin = $('#map-pin').val();

    var marker = new google.maps.Marker({
      position  : latlng,
      map     : map,
      icon: map_pin
    });

    // add to array
    map.markers.push( marker );

    // if marker contains HTML, add it to an infoWindow
    if( $marker.html() )
    {
      // create info window
      var infowindow = new google.maps.InfoWindow({
        content   : $marker.html()
      });

      // show info window when marker is clicked
      google.maps.event.addListener(marker, 'click', function() {

        infowindow.open( map, marker );

      });
    }
  }

  // Center map
  function center_map( map ) {

    // vars
    var bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    $.each( map.markers, function( i, marker ){

      var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

      bounds.extend( latlng );

    });

    // only 1 marker?
    if( map.markers.length === 1 )
    {
      // set center of map
        map.setCenter( bounds.getCenter() );
        // map.setZoom( 16 );
    }
    else
    {
      // fit to bounds
      map.fitBounds( bounds );
    }

  }


  // Generate map
  function new_map( $el ) {
    // var
    var $markers = $el.find('.marker');
    
    // vars
    var args = {
      zoom    : 18,
      center    : new google.maps.LatLng(0, 0),
      mapTypeId : google.maps.MapTypeId.ROADMAP,
      scrollwheel: false,
      styles:[
      {
          "stylers": [
              {
                  "visibility": "on"
              },
              {
                  "saturation": -100
              },
              {
                  "gamma": 0.54
              }
          ]
      },
      {
          "featureType": "road",
          "elementType": "labels.icon",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "water",
          "stylers": [
              {
                  "color": "#4d4946"
              }
          ]
      },
      {
          "featureType": "poi",
          "elementType": "labels.icon",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "poi",
          "elementType": "labels.text",
          "stylers": [
              {
                  "visibility": "simplified"
              }
          ]
      },
      {
          "featureType": "road",
          "elementType": "geometry.fill",
          "stylers": [
              {
                  "color": "#ffffff"
              }
          ]
      },
      {
          "featureType": "road.local",
          "elementType": "labels.text",
          "stylers": [
              {
                  "visibility": "simplified"
              }
          ]
      },
      {
          "featureType": "water",
          "elementType": "labels.text.fill",
          "stylers": [
              {
                  "color": "#ffffff"
              }
          ]
      },
      {
          "featureType": "transit.line",
          "elementType": "geometry",
          "stylers": [
              {
                  "gamma": 0.48
              }
          ]
      },
      {
          "featureType": "transit.station",
          "elementType": "labels.icon",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "road",
          "elementType": "geometry.stroke",
          "stylers": [
              {
                  "gamma": 7.18
              }
          ]
      }
    ]};
    
    // create map           
    var map = new google.maps.Map( $el[0], args);
    
    // add a markers reference
    map.markers = [];
    
    // add markers
    $markers.each(function(){
      add_marker( $(this), map );
    });

    // center map
    center_map( map );
    
    // return
    return map;
  }

  var map = null;

  $('.acf-map').each(function(){
    var map_width = $('.acf-map').width();
    $('.acf-map').height(map_width);

    // create map
    map = new_map( $(this) );
  });

})(jQuery);




/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        // Announcement banner
        $('.announcement-close').on('click', function(e) {
          e.stopPropagation();
          e.preventDefault();

          $('#announcement-overhead').hide();
          const tomorrowDate = new Date();
          tomorrowDate.setTime(d.getTime() + (24 * 60 * 60 * 1000));

          const tomorrowString = tomrrowDate.toUTCString();
          document.cookie = "announcement_close=true; " + tomorrowString + "; path=/";
        });

        // Get the current window width
        function getWindowWidth(){
          var bodyOverflowX = $('body').css('overflow-x');
          var bodyOverflowY = $('body').css('overflow-y');
          $('body').css('overflow', 'hidden');
          var windowWidth = $(window).width();
          $('body').css({
            'overflowX': bodyOverflowX,
            'overflowY': bodyOverflowY
          });

          return windowWidth;
        }

        var windowWidth = getWindowWidth();

        // Match Height fucntion
        function matchHeights() {

          // if( $('.sidebar').length ){
            $('.match-side').matchHeight();
          // }

          if( windowWidth > 767 ) {

            // Match Heights
            $('.header-match').matchHeight({byRow: true});
            $('.services .service .inr').matchHeight({byRow: true});
            $('.news .news-single h3').matchHeight({byRow: true});
            $('.news .news-single .content').matchHeight({byRow: false});

            // Set opacity to 1 after matching heights
            $('.header-match .inr').css('opacity', '1');
            $('.services').css('opacity', '1');
            $('.news').css('opacity', '1');

          } else {
            $('.header-match .inr').css('opacity', '1');
            $('.services').css('opacity', '1');
            $('.news').css('opacity', '1');
          }

        }


        // Functions to fire on document ready and window resize
        function onReadyResponsive(initial, windowWidth){ }

        // Functions to fire on window load and window resize
        function onLoadResponsive(initial, windowWidth){
          matchHeights();
        }

        // Responsive sidebar
        if( windowWidth < 992 ) {

          if( $('.sidebar').length ) { // Check if sidebar exists
            $('.sidebar').insertBefore('.main'); // Move before main 
            $('.sidebar-primary .wrap .content').css('opacity', '1'); // Set content opacity to 1, set 0 in css

            // Trigger toggle
            $('#toggle-side').click(function(){
              $('#toggle-side').toggleClass('open');
              $('.sidebar .inr li.pagenav >ul').stop().slideToggle();
            });
          } else {
            $('.sidebar-primary .wrap .content').css('opacity', '1'); // Set content opacity to 1, set 0 in css
          }

        }


        // Toggle mobile menu
        $('#toggleMobileMenu').click(function(){
          $('.banner, #mobileMenu, #toggleMobileMenu').toggleClass('open');
          $('#mobileMenu').stop().slideToggle('slow');
        });


        $( '.wpcf7 #date' ).datepicker({
          showOn: 'both',
          buttonImage: '',
          buttonImageOnly: false,
          buttonText: '',
          showOtherMonths: true,
          selectOtherMonths: true,
          dateFormat: 'dd/mm/yy',
        });

        var copy_btn = document.getElementById('copy-link');

        if( copy_btn !== null ){
          var clipboard = new Clipboard(copy_btn);

          clipboard.on('success', function(e) {
            $('#message').append('<div id="copy-success">Link copied successfully</div>');
            $('#message').css('opacity', '1').delay(8000).css('opacity', '0');
          });
          clipboard.on('error', function(e) {
            $('#message').append('<div id="copy-fail">Link copy failed</div>');
            $('#message').css('opacity', '1').delay(8000).css('opacity', '0');
          });
        }



        $(window).load(function(){
          onLoadResponsive(true, getWindowWidth());
        });

        $(window).resize(function() {
          var windowWidth = getWindowWidth();
          onLoadResponsive(false, windowWidth);
          onReadyResponsive(false, windowWidth);
        });



      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
